module.exports = __webpack_public_path__ + "static/media/3-infrastructure.a0bcc2bb.svg";